const fns: any[] = [];

export function register(fn) {
    fns.push(fn);

    return function() {
        _.pull(fns, fn);
    };
}

export function execute(expiry) {
    return Promise.all(fns.map(f => f(expiry)));
}
